import type { QcSummary, RecordingMode } from "../api/types";

/** A gate reason without the capture-mode jargon ("mode2 recording without ..." ->
 * "recording without ..."), for demo sessions. */
export function withoutMode(reason: string): string {
  const out = reason.replace(/\bmode ?[12]\b\s*/gi, "").trim();
  return out ? out[0].toUpperCase() + out.slice(1) : reason;
}

/** True when the pipeline ran QC and the recording failed the gate. */
export function gateFailed(qc: QcSummary | null | undefined): boolean {
  return qc?.passed === false;
}

/** Why the gate failed. Prefers the reasons the worker recorded; recordings processed
 * before that field existed get the same rules re-derived from the QC numbers. */
export function gateFailures(qc: QcSummary | null | undefined, mode: RecordingMode): string[] {
  if (!qc || qc.passed !== false) return [];
  if (qc.gate_failures && qc.gate_failures.length > 0) return qc.gate_failures;
  const out: string[] = [];
  if (qc.conform_passed === false) out.push("conformance validator failed");
  if (qc.is_emulator) out.push("captured on an Android emulator (synthetic, never valid training data)");
  if (!qc.frame_count) out.push("no video frames");
  if (qc.imu_rate_hz == null) out.push("no IMU data (rate unknown)");
  else if (qc.imu_rate_hz < 50 || qc.imu_rate_hz > 1000)
    out.push(`IMU rate ${Math.round(qc.imu_rate_hz)} Hz outside the 50-1000 Hz range`);
  if (mode === "mode2" && qc.tracking_pct == null) out.push("mode2 recording without ARCore tracking data");
  if (out.length === 0) out.push("QC gate failed (reason not recorded by this pipeline version)");
  return out;
}
